import dayjs from "dayjs";
import React from "react";
import { FormatCurrencyWithoutSymbol } from "../../../../../Services/Utils";

export const columns = (tab) => [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "paymentDate",
        label: "Tanggal BKM",
        options: {
            sort: false,
        },
    },
    {
      name: "paymentRealizationDate",
      label: "Tanggal Realisasi BKM",
      options: {
        sort: false,
        display: tab === "REALISASI"
      },
    },
    {
        name: "paymentCashId",
        label: "Nomor BKM",
        options: {
            sort: false,
        },
    },
    {
        name: "documentType.value",
        label: "Jenis Dokumen",
        options: {
            sort: false,
        },
    },
    {
        name: "documentRef1",
        label: "No. Dokumen Ref 1",
        options: {
            sort: false,
        },
    },
    {
        name: "documentRef1Date",
        label: "Tanggal Dokumen Ref 1",
        options: {
            sort: false,
        },
    },
    {
        name: "cashCode",
        label: "Kode Kas",
        options: {
            sort: false,
        },
    },
    {
        name: "transactionPersonName",
        label: "Terima Dari",
        options: {
            sort: false,
        },
    },
    {
        name: "paymentAmount",
        label: "Nilai Rupiah",
        options: {
            customBodyRender: (value, _) => {
              return (
                <>{FormatCurrencyWithoutSymbol({ number: value })}</>
              );
            },
            sort: false,
        },
    },
    {
        name: "printCount",
        label: "Count Cetakan",
        options: {
            sort: false,
        },
    },
    {
        name: "printStatus",
        label: "Status Cetakan",
        options: {
            sort: false,
        },
    },
];

export const formGroup = {
    kodeKas: {value: null, mandatory: true},
    namaTerimaDari: {value: "", mandatory: true},
    nilaiRupiah: {value: 0, mandatory: true},
    terbilang: {value: ""},
    jenisRelasi: {value: null, mandatory: true},
    gunaMembayar: {value: "", mandatory: true},
    keterangan: {value: "", mandatory: true},
    jenisTransaksi: {value: null, mandatory: true},
    jenisDokumen: {value: null, mandatory: true},
    realisasi: {value: false},
    dataSpecialCategory: {value: null},
};

export const reportType = {
    FJ: "SALES_ORDER",
    SCP: "SALES_ORDER_SCP",
    FJ_CANCELED: "SALES_ORDER_BATAL",
    SCP_CANCELED: "SALES_ORDER_SCP_BATAL",
};
